import type { AppCreateClass } from "@shared/models/analytics/app"
import type { FindFn } from "@shared/models/analytics/base"
import { createBlankEvent } from "@shared/models/analytics/base"
import type { PreparedAction } from "../../action-doc-builder"
import { partial } from "lodash-es"
import type { Narrative } from "../create-narrative"
import createNarrative from "../create-narrative"

interface Payload {
  cardStackId: string
  templateTitle: string
}

export default function createClassEditTemplateAction(payload: Payload): PreparedAction {
  return {
    name: "CREATE_CLASS_EDIT_TEMPLATE",
    payload: payload,
    patches: null,
    undoPatches: null,
    narrative: partial(narrative, payload),
  }
}

function narrative(payload: Payload, _findFn: FindFn, _userId: string): Narrative {
  let newEvent: AppCreateClass = {
    ...createBlankEvent(),
    root_id: null,
    root_type: "app",
    date_plan_scheduled_for: null,

    primary_verb: "use",
    primary_possessive: "owns",

    primary_object_type: "app",
    primary_object_id: "commoncurriculum.com",
    primary_object_specifier: "course_create",
    primary_object_id_and_ancestor_ids: ["commoncurriculum.com"],

    adverbial_verb: "editing",

    adverbial_object_type: "template",
    adverbial_object_id: payload.cardStackId,
    adverbial_object_specifier: null,
    adverbial_object_id_and_ancestor_ids: ["commoncurriculum.com"],
  }
  return createNarrative({
    title: `Editing the ${payload.templateTitle} template`,
    titleForAnalytics: "Create Class - Edit Template",
    description: `Creating a class from the Planner`,
    newAnalyticsEvents: [newEvent],
  })
}
